import { render, staticRenderFns } from "./BacktoTop.vue?vue&type=template&id=c722f71e&"
import script from "./BacktoTop.vue?vue&type=script&lang=js&"
export * from "./BacktoTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports